import { Description } from '@material-ui/icons'
import * as Yup from 'yup'
import { t } from 'i18next'

const currentYear = new Date().getFullYear()
const currentMonth = new Date().toLocaleString('en-US', { month: 'long' })

const monthOptions = [
    { id: '', description: 'Select Month' },
    { id: 'January', description: 'January' },
    { id: 'February', description: 'February' },
    { id: 'March', description: 'March' },
    { id: 'April', description: 'April' },
    { id: 'May', description: 'May' },
    { id: 'June', description: 'June' },
    { id: 'July', description: 'July' },
    { id: 'August', description: 'August' },
    { id: 'September', description: 'September' },
    { id: 'October', description: 'October' },
    { id: 'November', description: 'November' },
    { id: 'December', description: 'December' },
]

const carValidationSchemas = () => [
    Yup.object().shape({
        // title: Yup.string().required('Title is required!'),
        // description: Yup.string().required('Description is required!'),
        regNum: Yup.string().required(`Registration number ${t('is_required')}!`),
        mileage: Yup.number()
            .required(`Mileage ${t('is_required')}!`)
            .max(100000, 'Mileage cannot be more than 100,000 miles!'),
        // start_date: Yup.date().nullable().required('Start date is required!'),
        // end_date: Yup.date().nullable().required('End date is required!'),
        // city: Yup.string().required('City is required!'),
        // state: Yup.string().required('State is required!'),
        // country: Yup.string().required('Country is required!'),
        // phonenumber: Yup.string()
        //     .matches(/^\+?\d{10,15}$/, 'Phone number must be between 10 to 15 digits')
        //     .required('Phone number is required'),
        // zipcode: Yup.string()
        //     .matches(/^\d{5,6}$/, 'Zip code should be 5 or 6 digits')
        //     .required('Zip code is required'),
    }),
    Yup.object().shape({
        keys: Yup.string().required('Car keys are required!'),
        tyres: Yup.string().required(`Tyre condition ${t('is_required')}!`),
        year: Yup.string().required(`Maintenance year ${t('is_required')}!`),
        month: Yup.string()
            .required(`Maintenance month ${t('is_required')}!`)
            .test('valid-month', 'Cannot select a future month for the current year', function (
                value,
            ) {
                const selectedYear = parseInt(this.parent.year, 10)

                console.log('Selected Year:', selectedYear)
                console.log('Current Year:', currentYear)
                console.log('Selected Month:', value)
                console.log('Current Month:', currentMonth)

                if (selectedYear === currentYear) {
                    const monthIndex = monthOptions.findIndex((m) => m.id === value)
                    const currentMonthIndex = monthOptions.findIndex((m) => m.id === currentMonth)

                    console.log('Selected Month Index:', monthIndex)
                    console.log('Current Month Index:', currentMonthIndex)

                    if (monthIndex === -1) return false

                    return monthIndex <= currentMonthIndex
                }
                return true
            }),
        leasingValue: Yup.string().required(`Leasing status ${t('is_required')}!`),
        financeValue: Yup.string().when('isLeased', {
            is: 'no',
            then: Yup.string().required(`Financing status ${t('is_required')} if not leased`),
        }),
        paidOff: Yup.string().when('isFinanced', {
            is: 'yes',
            then: Yup.string().required(`Paid off status ${t('is_required')} for financed cars`),
        }),
        specificDetails: Yup.string().required(`Car details ${t('is_required')}!`),
        damageNotes: Yup.string().required(`Car issues ${t('is_required')}!`),
    }),
    Yup.object().shape({
        vehicle_interior: Yup.array()
            .min(3, 'Please upload at least 3 interior images')
            .required('Interior images are required'),
        vehicle_exterior: Yup.array()
            .min(4, 'Please upload at least 4 exterior images')
            .required('Exterior images are required'),
        // service_book: Yup.array()
        //     .min(4, 'Please upload at least 4s service book document')
        //     .required(`Service book document ${t('is_required')}`),
        // scratches_dents: Yup.array()
        //     .min(1, 'Please upload at least 1 image of scratches or dents')
        //     .required('Scratches/Dents images are required'),
    }),
    Yup.object().shape({
        price: Yup.number().required(`Price ${t('is_required')}!`),
    }),
]

export default carValidationSchemas
